import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/img/logo.png'


const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "heading" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  }),
  /*#__PURE__*/_createTextVNode(),
  /*#__PURE__*/_createElementVNode("span", null, "LOGGER")
], -1)
const _hoisted_3 = { class: "logger mt-4" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "mb-4" }, "Вход", -1)
const _hoisted_5 = { class: "logger-form" }
const _hoisted_6 = { class: "buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_tirscript3_input = _resolveComponent("tirscript3-input")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_tirscript3_button = _resolveComponent("tirscript3-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("form", _hoisted_5, [
        _createVNode(_component_tirscript3_input, {
          onKeyup: _withKeys(_ctx.onPasswordFocus, ["enter"]),
          class: "login",
          modelValue: _ctx.loginModel.Email,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.loginModel.Email) = $event)),
          type: "text",
          placeholder: "Логин"
        }, null, 8, ["onKeyup", "modelValue"]),
        _createVNode(_component_tirscript3_input, {
          onKeyup: _withKeys(_ctx.onLogin, ["enter"]),
          class: "password",
          type: "password",
          modelValue: _ctx.loginModel.Password,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.loginModel.Password) = $event)),
          placeholder: "Пароль",
          autofocus: _ctx.autofocusPasswordInput
        }, null, 8, ["onKeyup", "modelValue", "autofocus"]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_router_link, { to: "password-recovery" }, {
            default: _withCtx(() => [
              _createTextVNode("Забыли пароль?")
            ]),
            _: 1
          }),
          _createVNode(_component_tirscript3_button, { onOnClick: _ctx.onLogin }, {
            default: _withCtx(() => [
              _createTextVNode("Войти")
            ]),
            _: 1
          }, 8, ["onOnClick"])
        ])
      ])
    ])
  ]))
}